import { OnlineType } from '../constant/OnlineType';
import type { UtmCampaign } from '../constant/utm';
import { UtmKey, UtmMediumSharedDoc, UtmSource } from '../constant/utm';

export function generateUrlWithUtm(url: string, utmCampaign: UtmCampaign, onlineType: OnlineType) {
  const urlObj = new URL(url);
  urlObj.searchParams.set(UtmKey.Source, UtmSource);
  urlObj.searchParams.set(
    UtmKey.Medium,
    (() => {
      if (onlineType === OnlineType.SharedDoc) {
        return UtmMediumSharedDoc;
      }
      return window.location.host;
    })(),
  );
  urlObj.searchParams.set(UtmKey.Campaign, utmCampaign);
  urlObj.searchParams.set(UtmKey.Content, window.location.href);
  return urlObj.toString();
}
